<div class="map-list-result-row" style="padding-top: 4px; overflow: auto;" *ngIf="map">
    <div class="flex-container">
        <span class="indented">
            <i class="icon-ui-globe shared-map" *ngIf="!owner && !map.isSystem" title="Shared Map"></i>

            <a class="pointer name" (click)="toggleMapItem()" [title]="map.id">
                <span *ngIf="map.isPublic" class="icon-ui-link-external" title="Public"></span> {{ map.name }}
            <span *ngIf="mapItemType !== 'System'" class="map-result-view-date"> - {{ map.createdDate | date:'short' }}</span>
                <span class="caret"> <i [class]="showMapDetailIcon" (click)='getMapDetails(map)'></i></span>
            </a>
        </span>

        <div *ngIf="!mergeMaps && !multiSelectEnabled" class="buttons">
            <button title="Open Map" type="button"
                    class="btn btn-info btn-small open mc-btn-my-maps-actions" (click)="openMap()">
                <span class="icon-ui-applications" aria-hidden="true"></span>
            </button>
            <button *ngIf="!map.isSystem" title="Share Map" type="button"
                    class="btn btn-primary btn-small share mc-btn-my-maps-actions" (click)="shareMap()">
                <span class="icon-ui-share" aria-hidden="true"></span>
            </button>
            <button *ngIf="!map.isSystem && map.sharedWith?.length" title="Unshare Map" type="button"
                    class="btn btn-yellow btn-small unshare mc-btn-my-maps-actions" (click)="unshareMap()">
                <span class="icon-ui-user" aria-hidden="true"></span>
            </button>
            <button *ngIf="!map.isSystem" title="Move to Folder" type="button"
                    class="btn btn-default btn-small move-to-folder mc-btn-my-maps-actions" (click)="changeFolder(map)">
                <span class="icon-ui-tag" aria-hidden="true"></span>
            </button>
            <button *ngIf="!map.isSystem" title="Delete Map" type="button"
                    class="btn btn-danger btn-small delete mc-btn-my-maps-actions" (click)="deleteMap(map)">
                <span class="icon-ui-trash" aria-hidden="true"></span>
            </button>
        </div>
        <div *ngIf="!mergeMaps && multiSelectEnabled" class="buttons">
            <input type="checkbox" class="checkbox" (click)="toggleMultiSelectCheckbox($event)" />
        </div>

        <div *ngIf="mergeMaps">
            <!--Show only merge map button for merge maps tool-->
            <button *ngIf="!multiSelectEnabled" title="Merge Map" type="button"
                    class="btn btn-primary btn-small merge mc-btn-my-maps-actions" (click)="mergeMap()">
                <span class="icon-ui-directions2" aria-hidden="true"></span>
            </button>
        </div>
    </div>
    <div *ngIf="expanded" style="margin-left: 25px">
        <div>
            <strong>Description:</strong>
            <p>{{ map.description || 'No description available' }}</p>
            <span *ngIf="showMap && showMap.Map.owner">
                <strong>Created by: </strong>
                <span>{{ showMap?.Map.owner?.firstName }} {{ showMap?.Map.owner?.lastName }} (<a href="mailto:{{ showMap?.Map.owner?.email }}">{{ showMap?.Map.owner?.email }}</a>)</span><br />
            </span>
            <strong>Created Date: </strong>
            <span *ngIf="map.createdDate">{{ map.createdDate }}</span>
            <span *ngIf="!map.createdDate">NA</span><br />
            <strong>Last Updated: </strong>
            <span *ngIf="map.lastEditedDate">{{ map.lastEditedDate }}</span>
            <span *ngIf="!map.lastEditedDate">NA</span>
            <span *ngIf="map.isPublic">
                <br />
                <strong>Public Link: </strong>
                <span><a href="{{ publicUrl }}" target="_blank" rel="noopener">{{ publicUrl }}</a></span>
            </span>
        </div>
        <div>
            <strong>Layers:</strong>
            <ul>
                <li *ngIf="!showMap?.Map.layers?.length">No layer data available.</li>
                <li *ngFor="let layer of showMap?.Map.layers">{{ layer.name }}</li>
            </ul>
        </div>
    </div>
</div>
